<template>
    <div class="w-full flex flex-row mb-3 xl:mb-5 align-items-center">
        <div class="block relative bg-green-200 border-circle mr-2 xl:mr-2 height-3 width-3 p-3 xl:p-4">
            <span class="absolute text-xl text-0 left-0 font-medium top-0 ml-2 mt-2 xl:ml-3 xl:mt-3">2</span>
        </div>
        <span class="flex flex-1 text-700 font-medium xl:text-xl">
            {{ content[lang_].from }}
        </span>
    </div>
    <div class="w-full flex flex-column xl:flex-row relative gap-2">
        <div class="w-full flex max-w-30rem relative gap-2
            flex-column xl:flex-row lg:flex-row
            surface-0 xl:surface-100 lg:surface-100 md:surface-100
            border-round-2xl 
            p-3 xl:p-4">
            <Button label="Чат на сайте" @click="chatWeb()" icon="pi pi-comments" iconPos="left"
                class="border-round-lg border-none border-round-xl border-ios-2xl" severity="success" size="large"/>
            <Button v-if="!isTgApp" label="Чат в телеграм" @click="chatTg()" icon="pi pi-telegram" iconPos="left"
                class="border-round-lg border-none border-round-xl bg-telegram border-ios-2xl" severity="info" size="large"/>
        </div>
    </div>
</template>

<script>
import Helper from '@/assets/js/Helper'
export default {
    props: [],
	data(){
		return{
			content: {
				en: {
					from: "Get payment details in chat",
                    to: "to the card ",
                    copied: "Copied",
                    phone_number: 'SBP phone number',
                    account_number: 'Account number',
                    name: 'Recipient name',
                    bank: 'Recipient bank',
                    message: 'Your funds are securely protected by the PayWave secure transaction system.',
                    sbp_alert: 'Attention! Transfer via FPS only to the bank'
				} ,
				ru: {
                    from: "Получите реквизиты для оплаты в чате",
                    to: "на карту ",
                    copied: "Скопировано",
                    phone_number: 'Номер телефона СБП',
                    account_number: 'Номер счета',
                    name: 'Имя получателя',
                    bank: 'Банк получателя',
                    message: 'Ваши средства надежно защищены системой безопасных сделок PayWave.',
                    sbp_alert: 'Внимание! Переводите по СБП только на банк'
				},
			}, 
		}
	},
	computed: {
		lang_() {
			return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
		},
        isTgApp: function () { return this.$store.getters.StateTgApp },
	},
	methods: {
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: this.content[this.lang_].copied, detail: text, life: 1000 })
        },
        get_bank_title(code){
            return this.helper.get_bank_title(code, this.$store.state.payment.banks, this.lang_)
        },
        get_bank_image(code){
            return this.helper.get_bank_image(code, this.$store.state.payment.banks)
        },
        chatWeb(){
            try {
                BrevoConversations('openChat')
            } catch (e) {
                console.log(e)
            }
        },
        chatTg(){
            try { window.open('https://t.me/pw_origin_bot', '_blank')
            } catch(e){ console.log(e) }
        }
	},
	beforeCreate() {
        this.helper = new Helper()    
	}
}
</script>